export const scrollButton = function() {
	const jump = jumper();
	const scrollBtn = document.querySelector('.homepage-carousel__scroll');
	if (!scrollBtn) return;
	scrollBtn.addEventListener('click', _=> {
		const scrollToEl = document.querySelector('.first-section');
		if (!scrollToEl) return;
		jump(scrollToEl);
	})
}
